export const Ruby = ({ data = [], className = "", testid }) => (
  <span className={`inline-flex flex-wrap items-center ${className}`} data-testid={testid}>
    {data.map(([c, z], i) => (z ? (
      <span key={i} className="zy-cell"><span>{c}</span><span className="zy-mark">{z}</span></span>
    ) : <span key={i}>{c}</span>))}
  </span>
);
